module.exports = __webpack_public_path__ + "static/img/2661_phase_function_Paper_Points.c39fb7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2661_phase_function_Paper_Points.png
// module id = KC09
// module chunks = 0